<template>
  <div class="service-factory">
     <h2>工廠</h2>
     <p>金牌王國是臺灣銀樓公司，與鑫昌貴金屬行的關係企業，自1972年開始，擁有自己打金工廠，與國寶級打金師傅。產品與服務包括鑄作宗教神尊、純金法器、金龜、金牌、金帽等，還有客制化禮贊金器。金牌是許多信徒、台灣民眾們作為求取事業工作、姻緣、科考、官運時作為酬神的物品，在金牌上刻上神明的稱謂、宮名並掛在神尊上或擺在供桌，非常具有意義。基於如此，金牌王國希望能夠提供快速方便的客製化金牌，也基於國際價格，公開透明的價格計算方式與即時報價系統，確保消費者權益、多一份安心。經由網站售出的商品也皆付買回機制，方便的訂購流程、簡單製作屬於自己的金牌，讓購買金牌這件事不再需要大費周章的到銀樓，也能夠擁有一份高品質保證的產品。</p>
     <div class="mobile_backNav" v-if="isMobileButtonShow">
       <i class="fa fa-angle-left"></i>
       <router-link to="/gold/service_mobile">返回說明與服務</router-link>
     </div>
  </div>
</template>

<script>
export default {
  name: "serviceFactory",
  data() {
    return {
      isMobileButtonShow: false
    };
  },
  created() {
    let device = this.$store.getters.getDeviceSize;
    if (device < 585) {
      this.isMobileButtonShow = true;
    }
  }
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}
.service-factory {
  width: 66.73%;
  text-align: left;
  min-height: calc(100vh - 377px);
  h2 {
    font-size: 35px;
    font-weight: 600;
    letter-spacing: 2px;
    color: $primaryDeepColor;
    margin-top: 0;
  }
  p {
    font-size: 17px;
    color: $secondaryDeepColor1;
    line-height: 30px;
  }
}
.mobile_backNav {
  margin-top: 24px;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  i {
    color: $primaryDeepColor;
    margin-right: 10px;
  }
  a {
    color: $primaryDeepColor;
  }
}
</style>
